// Modern Implantology Masterclass — module schedule
// Dates use Albanian month names, e.g. "5-6 Qershor 2026" (range) or "25 Tetor 2026" (single day).

// tx-catalog-start
export const masterclassModules = [
  { id: 1, title: "Bazat e Implantologjise", date: "5-6 Qershor 2026", speakers: ["Dr. Ardian Skendaj", "Dr. Ormir Bushati"], desc: "Hyrje ne implantologji, biologjia e implantit, anatomia kirurgjikale, teknikat baze dhe instrumentariumi." },
  { id: 2, title: "Vendosja e Implanteve dhe Komplikacionet", date: "12-13 Qershor 2026", speakers: ["Dr. Alesio Bocari", "Dr. Krenar Papraniku"], desc: "Teknikat e vendosjes, protokollet post-ekstraktive, menaxhimi i indeve te buta dhe komplikimet." },
  { id: 3, title: "Rigjenerimi i Drejtuar i Kockes (GBR)", date: "10-11 Korrik 2026", speakers: ["Dr. Guido Picciocchi"], desc: "GBR, biomaterialet, graftet kockore, membranat dhe fotografia klinike profesionale." },
  { id: 4, title: "Implantet Multiple, Kirurgjia e Sinusit dhe Planifikimi Strategjik", date: "4-5 Shtator 2026", speakers: ["Dr. Achraf Souayah"], desc: "Planifikimi biomekanik, strategjia e vendosjes, kirurgjia e sinusit maksilar dhe protokollet e avancuara." },
  { id: 5, title: "Epoka e Re e Rehabilitimit Full-Arch", date: "23-24 Tetor 2026", speakers: ["Dr. Eddy Marku", "Dr. Edison Shimaj"], desc: "Konceptet FP1/FP3, kirurgjia e guiduar, fotogrametria dhe live surgery All-on-6." },
  { id: 6, title: "Workflow Protetik dhe Laboratorik", date: "25 Tetor 2026", speakers: ["Dt. Hysen Dibra", "Dt. Klajdi Kapxhiu", "Dt. Samed Isufaj"], desc: "Workflow laboratorik, restaurimet provizore, passive fit dhe strukturat me titan." },
];
// tx-catalog-end

const AL_MONTHS = {
  janar: 0, shkurt: 1, mars: 2, prill: 3, maj: 4, qershor: 5,
  korrik: 6, gusht: 7, shtator: 8, tetor: 9, nentor: 10, dhjetor: 11,
};

/** Parse an Albanian date string like "5-6 Qershor 2026" or "25 Tetor 2026" into { start, end } Date pair. */
export const parseAlbanianDateRange = (str) => {
  if (!str) return null;
  const m = String(str).trim().match(/^(\d+)(?:-(\d+))?\s+([A-Za-zçÇëË]+)\s+(\d{4})$/);
  if (!m) return null;
  const startDay = parseInt(m[1], 10);
  const endDay = m[2] ? parseInt(m[2], 10) : startDay;
  const monthKey = m[3].toLowerCase().replace(/ë/g, "e").replace(/ç/g, "c");
  const month = AL_MONTHS[monthKey];
  const year = parseInt(m[4], 10);
  if (month === undefined || !startDay || !year) return null;
  const start = new Date(year, month, startDay, 9, 0, 0);
  const end = new Date(year, month, endDay, 23, 59, 59);
  return { start, end };
};

/**
 * Return the "next" module to promote in the homepage countdown:
 * 1) If today < start of the earliest upcoming module → return that module (countdown to its start).
 * 2) If a module is currently running (start ≤ today ≤ end) → return the module AFTER it (or that same
 *    one if it's the last, so its end date is shown).
 * 3) If all modules have ended → return null.
 */
export const getNextMasterclassModule = (today = new Date()) => {
  const withDates = masterclassModules
    .map((m) => ({ ...m, _range: parseAlbanianDateRange(m.date) }))
    .filter((m) => m._range);

  // Pick the first module whose END is still in the future
  const upcoming = withDates.find((m) => m._range.end.getTime() >= today.getTime());
  return upcoming || null;
};
